import React from 'react';
import {
  Box,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

type GroupNameInputProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const GroupNameInput: React.FC<GroupNameInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <Box>
      <FormLabel
        fontFamily="marketingPage"
        fontWeight={500}
        fontSize="16px"
        color="content.title"
        mb={3}>
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          bg="surface.panel"
          border="1px solid"
          borderColor="surface.border"
          borderRadius="md"
          py={3}
          px={4}
          fontSize="16px"
          fontFamily="marketingPage"
          _placeholder={{ color: 'content.muted' }}
          _focus={{
            borderColor: 'icon.green',
            boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
          }}
        />
        {placeholder && (
          <InputRightElement>
            <Icon iconName="pencil" boxSize={4} color="content.muted" />
          </InputRightElement>
        )}
      </InputGroup>
    </Box>
  );
};
